<template>
  <div class="report_branch mr-bt-table">
    <Table
      header="รายการยอดขายประจำสาขา"
      v-bind:columns="['เลขใบคำขอ','ชื่อ - สกุล','วันที่สร้าง','ทุนประกัน (บาท)','เบี้ยประกันก่อนภาษีและส่วนลด (บาท)','แผนประกัน','สถานะการจัดการกรมธรรม์','รหัสสาขา','รหัสเขต','รหัสพนักงาน']"
    >
      <template slot="search-box">
        <div class="col-sm-12">
          <section class="panel panel-default">
            <div class="panel-heading">
              <h4>ค้นหาข้อมูล</h4>
            </div>
            <div class="panel-body h5">

              <div class="col-lg-3 col-sm-6 col-xs-6 no-padd-m">
                <div class="form-group">
                  <label class="col-lg-2 control-label m-t-xs">ชื่อ:</label>
                  <div class="col-lg-10">
                    <input type="text" class="form-control input-sm" v-model="search.first_name"/>   
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-sm-6 col-xs-6 no-padd-m">
                <div class="form-group">
                  <label class="col-lg-3 control-label m-t-xs">นามสกุล:</label>
                  <div class="col-lg-9">
                    <input type="text" class="form-control input-sm" v-model="search.last_name"/>  
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-sm-12 col-xs-12 m-t-xs no-padd-m">
                <div class="form-group">
                  <label class="col-lg-2 col-xs-12 control-label m-t-xs">วันที่สร้าง:</label>
                  <div class="col-lg-4 col-xs-6">
                    <div class="input-group">
                      <DatePickerTH type="past" name="start_date" v-model="search.start_date" />
                      <span class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                      </span>
                    </div> 
                  </div>
                  <div class="col-lg-1 col-xs-1 text-center">
                    <span class="m-t-xs">-</span>
                  </div>
                  <div class="col-lg-4 col-xs-5">
                    <div class="input-group">
                      <DatePickerTH type="past" name="end_date" v-model="search.end_date" />
                      <span class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                      </span>
                    </div>  
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-sm-6 col-xs-6 m-t-xs no-padd-m">
                <div class="form-group">
                  <label class="col-lg-2 control-label m-t-xs">สถานะ:</label>
                  <div class="col-lg-10">
                      <select class="form-control input-sm" v-model="search.policy_status">
                        <option value="0" disabled selected>กรุณาเลือกสถานะ</option>
                        <option value="1">รอชำระเงิน</option>
                        <option value="2">ออกกรมธรรม์</option>
                        <option value="3">เลยกำหนดชำระเงิน</option>
                        <option value="4">ยกเลิกใบคำขอ</option>
                        <option value="5">ขาดเอกสาร</option>
                        <option value="6">ยกเลิกกรมธรรม์</option>
                      </select>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-sm-6 col-xs-6 m-t-xs no-padd-m">
                <div class="form-group">
                  <label class="col-lg-2 control-label m-t-xs">สาขา:</label>
                  <div class="col-lg-10">
                    <Branch v-model="search.branch"/>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-sm-12 col-xs-12 m-t-xs no-padd-m text-center-m">
                <button
                  type="button"
                  class="btn btn-default button-mt-sh10"
                  @click="searchReport()"
                >
                  <i class="glyphicon glyphicon-search"></i> ค้นหาข้อมูล
                </button>

                <download-excel
                  class="btn btn-dark button-mt-sh10"
                  style="margin-left:20px;"
                  :data="results"
                  :fields="json_fields"
                  worksheet="report"
                  name="report_branch.xls"
                >
                  <i class="fas fa-file"></i> EXPORT EXCEL
                </download-excel>
              </div>
              
            </div>
          </section>
        </div>
      </template>

      <template slot="main">
        <tr v-for="result in results">
          <td>
            <router-link :to="'/insurance_personal/'+result.applicationId" target="_blank">
              {{ result.applicationId }}
            </router-link>
          </td>
          <td>{{ result.firstName }} {{ result.lastName }}</td>
          <td>{{ formatDockDateTimeTh(result.createdTime) }}</td>
          <td>{{ (result.sumInsured) }}</td>
          <td>{{ numberWithCommas(result.grossPremium) }}</td>
          <td>{{ result.planName }}</td>
          <td>{{ statusPolicy(result.policyStatus) }}</td>
          <td>{{ result.branchId }}</td>
          <td>{{ result.districtId }}</td>
          <td>{{ result.staffId }}</td>
        </tr>

        <tr v-if="results.length==0">
          <td colspan="11">
            <div style="margin: 4em 0px;">ไม่พบข้อมูล</div>
          </td>
        </tr>
      </template>

      <template slot="paginate">
        <PaginateTable
          v-show="results.length!=0"
          v-model="pagination"
          :page="pagination.page"
          :per_page="pagination.per_page"
          :last_page="pageNum"
          :total="total"
        ></PaginateTable>
      </template>

    </Table>
  </div>
</template>

<script>
// @ is an alias to /src
import Table from "@/components/Table/Index.vue";
import DatePickerTH from "@/components/Form/DatePickerTH.vue";
import downloadExcel from "vue-json-excel";
import PaginateTable from "@/components/Table/PaginateTable.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import Branch from '@/components/List/Branch.vue'

export default {
  name: "branch",
  data() {
    return {
      pagination: {
        page: 1,
        per_page: 20
      },
      search: {
        policy_status: 0,
        start_date: {
          human: moment()
            .subtract(10, "days")
            .format("DD/MM/YYYY"),
          origin: moment()
            .subtract(10, "days")
            .format("YYYY-MM-DD")
        },
        end_date: {
          human: moment().format("DD/MM/YYYY"),
          origin: moment().format("YYYY-MM-DD")
        },
        branch : null,
        first_name: null,
        last_name: null
      },
      pageNum: 0,
      total: 0,
      results: [],
      json_fields: {
        เลขใบคำขอ: "applicationId",
        ชื่อ: "firstName",
        นามสกุล: "lastName",
        วันที่สร้าง: "createdTime",
        "ทุนประกัน (บาท)": {
          field: "sumInsured",
          callback: value => {
            return value;
            // `Landline Phone - ${value}`;
          }
        },
        "เบี้ยประกันก่อนภาษีและส่วนลด (บาท)": {
          field: "grossPremium",
          callback: value => {
            return value;
          }
        },
        แผนประกัน: "planName",
        สถานะการจัดการกรมธรรม์: {
          field: "policyStatus",
          callback: value => {
            return this.statusPolicy(value);
          }
        }
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ]
    };
  },
  watch: {
    pagination: function(val) {
      this.init();
    }
  },
  computed: {
    ...mapGetters([
      "statusPolicy",
      "env",
      "numberWithCommas",
      "formatDockDateTimeTh"
    ])
  },
  components: {
    Table,
    DatePickerTH,
    PaginateTable,
    downloadExcel,
    Branch
  },
  mounted() {
    $('input[name="start_date"]').val(this.search.start_date.human);
    $('input[name="end_date"]').val(this.search.end_date.human);
    // this.init();
  },
  methods: {
    searchReport() {
      this.pagination.page = 1;
      this.init();
    },
    init() {
      const CALL_API = this.env.VUE_APP_PATH_API;
      var search = {
        start_date: this.search.start_date.origin,
        end_date: this.search.end_date.origin,
        page: this.pagination.page,
        per_page: this.pagination.per_page
      };

      if (this.search.policy_status != "0") {
        search.policy_status = this.search.policy_status;
      }

      if(this.search.first_name != null){
         search.first_name = this.search.first_name;
      }

      if(this.search.last_name != null){
         search.last_name = this.search.last_name;
      }

      if(this.search.branch != null){
         search.branch_id = this.search.branch;
      }

      if (this.$session.get("chili").auth_from == "tvi") {
        search.staffid = "08010";
      }

      this.$http
        .get(`${CALL_API}report-branch`, {
          params: search,
          headers: {
            Authorization: "Bearer " + this.$session.get("chili").access_token,
            "x-auth-from": this.$session.get("chili").auth_from
          }
        })
        .then(
          response => {
            this.results = response.body.result.report;
            this.pageNum = response.body.result.pageNum;
            this.total = response.body.result.total;
          },
          response => {
            if (
              response.body.statusCode == 400 &&
              response.body.message == "Invalid data from db"
            ) {
              this.results = [];
            }
          }
        );
    }
  }
};
</script>

<style lang="scss">
</style>
